import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';

const BLACK_TEXT_COLOR = '#38323C';
const BLUE_HIGHLIGHT_COLOR = '#ecf4fa';
const BLUE_TITLE_COLOR = '#2d6da1';
const WHITE_COLOR = '#FFFFFF';

export const DEFAULT_STYLE_OPTIONS: IStyleOptions = {
    textColor: BLACK_TEXT_COLOR,
    titleColor: BLUE_TITLE_COLOR,
    backgroundColor: BLUE_HIGHLIGHT_COLOR,
    tableHeaderColor: BLACK_TEXT_COLOR,
    tableFooterColor: BLACK_TEXT_COLOR,
    backgroundColorPY: WHITE_COLOR,
};
